import React, {Component} from 'react'
import {connect} from 'react-redux'

import DocumentsTopBar from './DocumentsTopBar'

import {
    checkUrlExpired,
    resetTimer,
    showWarningDialogIE,
    countDownSessionTimeout
} from "../data/DocumentListActions";
import {Button, Col, FormControl, Image, Modal, ModalBody, ModalFooter, ModalHeader, Row} from "react-bootstrap";
import {displayLoading, fetchJson, getMonthName} from "../lib/ACHelpers";
import Dropzone from "react-dropzone";
import {persistImage} from "../data/EditorActions";
import axios from "axios";
import {FILE_SIZE_UPLOAD_LIMIT} from "../data/constant";
import OfflineSaveService from '../services/OfflineSaveService';

const ASC = 'ASC';
const DESC = 'DESC';

class ClipArtManagementPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isShowErrorMsg: false,
            isDisableRefreshClipArtButton: false,
            isShowResultBox: false,
            numberNewClipArt: 0,
            numberDeletedClipArt: 0,
            documentDates: [],
            monthYear: '',
            dateMonthsList: [],
            page: 1,
            limit: 50,
            month: 0,
            year: 0,
            clipArts: [],
            totalPage: 1,
            isNextPage: false,
            isPrevPage: false,
            keyword: '',
            deleteClipArts: [],
            clipArtPreview: null,
            sortName: '',
            sortCategory: '',
            sortText: '',
            textWarning: '',
            intervalCheckSessionTimeout: null,
        };
        sessionStorage.setItem('start_time', JSON.stringify(Date.now()));
    }

    componentDidMount = async () => {
        await checkUrlExpired();
        if (this.props.currentUser) {
            const {userId} = this.props.currentUser;
            if (userId) {
                sessionStorage.setItem('uid', JSON.stringify(userId));
            }
        }

        document.addEventListener('mousedown', () => resetTimer());
        document.addEventListener("keydown", () => resetTimer());

        document.getElementById('close-toast').addEventListener('click', () => {
            const toast = document.getElementById("snackbar");
            toast.className = toast.className.replace("show", "");
        });
        let startTime = Date.now();
        let endpoint = "/clipArts/year-months";
        let monthsList = [];

        await fetchJson(endpoint)
            .then(json => {
                if (json.data && json.data.length) {
                    monthsList = [...json.data];
                }
            });

        let dateMonthsList = monthsList.map(value =>
            new Date(value.year, value.month - 1, 1)
        );

        const now = new Date();
        let datesList = [];

        for (let i = 0; i < 4; i++) {
            const nextMonth = new Date(now.getFullYear(), now.getMonth() + i, 1);
            datesList = [...datesList, nextMonth]
        }

        datesList.map((date) => {
            if (!this.isExistsInMonths(date.getMonth() + 1, date.getFullYear(), monthsList)) {
                dateMonthsList = [...dateMonthsList, date]
            }
        });

        dateMonthsList = dateMonthsList.sort((a, b) => b - a);
        this.setState({
            dateMonthsList
        });

        await this.fetchClipArtsList({});
        this.state.intervalCheckSessionTimeout = window.setInterval(async function () {
            await countDownSessionTimeout();
        }.bind(this), 1000);

        OfflineSaveService.getInstance().startSaveProcess(this.props);
    };

    fetchClipArtsList = async ({page = this.state.page, limit = this.state.limit, month = this.state.month, year = this.state.year, keyword = this.state.keyword, sortText = this.state.sortText}) => {
        displayLoading(true);
        let endpointList = '/clipArts/list';
        endpointList += `?limit=${limit}&page=${page}`;
        if (month) {
            endpointList += `&month=${month}`;
        }

        if (year) {
            endpointList += `&year=${year}`;
        }

        if (keyword && keyword !== "") {
            endpointList += `&keyword=${keyword}`;
        }

        if (sortText && sortText !== '') {
            endpointList += `&sort=${sortText}`
        }
        try {
            await fetchJson(endpointList)
                .then(json => {
                    if (json.data) {
                        let clipArts = json.data;
                        clipArts = clipArts.map(item => {
                            return {...item, isChecked: false}
                        });
                        this.setState({
                            clipArts,
                            isNextPage: json.isNextPage,
                            isPrevPage: json.isPrevPage,
                            totalPage: json.totalPage,
                        });
                    }
                    displayLoading(false);
                }).catch(error => {
                    console.error(error);
                    displayLoading(false);
                });
        } catch (e) {
            displayLoading(false);
        }
    };

    componentWillUnmount() {
        if(this.state.intervalCheckSessionTimeout) {
            window.clearInterval(this.state.intervalCheckSessionTimeout);
        }
        document.removeEventListener("mousedown", () => resetTimer());
        document.removeEventListener("keydown", () => resetTimer());
    }

    isExistsInMonths = (month, year, monthsList) => {
        const listFilter = monthsList.filter(item => item.year == year && item.month == month);
        return listFilter && listFilter.length;
    };

    onDrop = async (files) => {
        const validFileTypes = ['image/png', 'image/jpeg', 'image/pjpeg', 'image/gif', 'image/bmp', 'image/x-windows-bmp']
        displayLoading(true);
        var matchedFile = undefined;
        // FILE_SIZE_UPLOAD_LIMIT
        if (files.length > 400) {
            this.setState({
                textWarning: 'One or more of your files is too large, please limit individual files to 10MB or smaller.'
            });

            displayLoading(false)
            return ;
        }
        const isOverSize = files.find(file => file.size > FILE_SIZE_UPLOAD_LIMIT*1024*1024);
        if (isOverSize) {
            this.setState({
                textWarning: 'At least one file exceeds the size limit of 10MB; please select smaller files.'
            });
            displayLoading(false);
            return ;
        }
        const isHasImage = files.find(file => validFileTypes.includes(file.type));
        if (isHasImage) {
            let count = 1;
            files.forEach((file) => {
                if (validFileTypes.includes(file.type)) {
                    matchedFile = file;
                    try{
                        if (matchedFile !== undefined) {
                            var formData = new FormData();
                            formData.append('image', matchedFile, Date.now() + '.' + matchedFile.name.split('.').pop());
                            formData.append('month', this.state.month);
                            formData.append('year', this.state.year);
                            formData.append('name', matchedFile.name);
                            this.props.dispatch(persistImage(formData)).then(async () => {
                                await this.setState({
                                    page: 1,
                                    keyword: '',
                                    sortCategory: '',
                                    sortName: '',
                                    sortText: ''
                                });

                                if(count >= files.length) {
                                    await this.fetchClipArtsList({page: 1, keyword: '', sortText: ''});
                                    displayLoading(false);
                                }
                                count++;
                            }).catch(error => {
                                console.error(error);
                                displayLoading(false);
                            });
                            // optionally tell our parent to anticipate an upload event
                            // currently we use this to scroll to the newly added file
                            if (this.props.onUpload !== undefined) {
                                this.props.onUpload(matchedFile)
                            }
                        }
                    } catch (e) {
                        console.error(error);
                        displayLoading(false);
                    }
                }
            });
        } else {
            displayLoading(false);
        }

    };

    monthDidChange = async (e) => {
        const monthYear = e.target.value;
        let month = this.state.month;
        let year = this.state.year;
        if (monthYear) {
            const monthYearSplit = monthYear.split(",");
            if (monthYearSplit && monthYearSplit.length > 1) {
                month = parseInt(monthYearSplit[0]);
                year = parseInt(monthYearSplit[1]);
            } else {
                month = 0;
                year = 0;
            }
        } else {
            month = 0;
            year = 0;
        }

        this.setState({
            monthYear,
            month,
            year,
            page: 1
        });

        await this.fetchClipArtsList({month, year, page: 1});
    };

    onClickPage = async (page) => {
        if (page < 1) {
            page = 1
        }

        if (page > this.state.totalPage) {
            page = this.state.totalPage
        }

        await this.fetchClipArtsList({page});
        this.setState(
            {
                page
            }
        )
    };

    onSearch = async (event) => {
        const keyword = event.target.value;
        this.setState({
            keyword,
            page: 1,
        });

        if (keyword && keyword.length >= 3 || (!keyword || keyword === '')) {
            await this.fetchClipArtsList({keyword, page: 1});
        }
    };

    generatePageNumber = () => {
        const pageList = [];
        if (this.state.totalPage <= 5) {
            for (let i = 1; i <= this.state.totalPage; i++) {
                pageList.push(<button key={i}
                                      className={`${i === parseInt(this.state.page) && 'active'} cursor-pointer`}
                                      onClick={() => this.onClickPage(i)}>{i}</button>)
            }
        } else {
            if (this.state.page <= 5) {
                for (let i = 1; i <= 5; i++) {
                    pageList.push(<button key={i}
                                          className={`${i === parseInt(this.state.page) && 'active'} cursor-pointer`}
                                          onClick={() => this.onClickPage(i)}>{i}</button>)
                }
            } else {
                for (let i = this.state.page - 5; i <= this.state.page; i++) {
                    pageList.push(<button key={i}
                                          className={`${i === parseInt(this.state.page) && 'active'} cursor-pointer`}
                                          onClick={() => this.onClickPage(i)}>{i}</button>)
                }
            }
        }


        return pageList;
    };

    checkClipArtItem = (clipArt) => {
        let clipArts = this.state.clipArts.map(item => {
            if (item.clipArtId === clipArt.clipArtId) {
                return {
                    ...item,
                    isChecked: !item.isChecked
                }
            }
            return item;
        });

        this.setState({
            clipArts
        })
    };

    checkedAll = () => {
        const checked = !this.state.clipArts.find(item => !item.isChecked);

        if (checked) {
            this.setState({
                clipArts: this.state.clipArts.map(item => {
                    return {...item, isChecked: false}
                })
            })
        } else {
            this.setState({
                clipArts: this.state.clipArts.map(item => {
                    return {...item, isChecked: true}
                })
            })
        }
    };

    removeClipArt = async () => {
        this.setState({
            deleteClipArts: []
        });

        const formData = new FormData();
        formData.append('clipArtsDelete', this.state.deleteClipArts);
        await axios.post('/clipArts/delete/multiple', Object.assign({}, {
            clipArtsDelete: this.state.deleteClipArts
        }))
            .then(function (response) {
            })
            .catch(function (error) {
                console.log(error)
            });

        if (this.state.page === parseInt(this.state.totalPage) && this.state.clipArts.every(item => item.isChecked)) {
            const newPage = this.state.page - 1;
            this.setState({
                page: newPage
            });
            await this.fetchClipArtsList({page: newPage});
        } else {
            await this.fetchClipArtsList({});
        }

    };

    onSort = async (key, secondSortKey, value) => {
        let sortText = `${key === 'sortName' ? 'name' : 'category'} ${value}`;

        if (this.state[secondSortKey] && this.state[secondSortKey] !== '') {
            if (sortText && sortText !== '') {
                sortText += `,${secondSortKey === 'sortName' ? 'name' : 'category'} ${this.state[secondSortKey]}`;
            } else {
                sortText = `${secondSortKey === 'sortName' ? 'name' : 'category'} ${this.state[secondSortKey]}`;
            }
        }

        this.setState({
            [key]: value,
            sortText
        });

        await this.fetchClipArtsList({
            sortText
        });
    };


    render = () => {
        let warnDiv = showWarningDialogIE();

        const dropperStyle = {
            backgroundPosition: 'center',
            backgroundSketch: 'original',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'contain',
        };

        return (
            <div>
                {
                    warnDiv &&
                    <div className="ac-toolbar ac-toolbar-top-menu">
                        {warnDiv}
                    </div>
                }

                <DocumentsTopBar currentUser={this.props.currentUser}></DocumentsTopBar>

                <div className="clip-wrap">
                    <div className="clipart-container">
                        <h3 className="text-left"><b>Update Clip Art Library</b></h3>
                        <div className="mt-15">
                            <i className="ma material-icons font-size-30">date_range</i>
                            <FormControl componentClass="select" placeholder="Select a month and year to manage"
                                         className="width-300" value={this.state.monthYear} key="month"
                                         id="month-picker" ref="monthPicker" onChange={this.monthDidChange}
                                         tabIndex="1">
                                <option key='' value=''>Select a month and year to manage</option>
                                {
                                    this.state.dateMonthsList.map((date, index) =>
                                        <option key={index}
                                                value={`${date.getMonth() + 1},${date.getFullYear()}`}>{`${getMonthName(date)} ${date.getFullYear()}`}</option>
                                    )
                                }
                            </FormControl>
                        </div>

                        <div className="mt-30 position-relative">
                            <div className={`${!this.state.monthYear && 'bg-disabled'}`}/>
                            <div style={{padding: '20px 40px'}}>
                                <h4 className="text-left">
                                    Upload clipart file(s)
                                </h4>
                                <form id="frmUpload" method="post" className="dropzone uploader-container">
                                    <Dropzone className="uploader" onDrop={this.onDrop} multiple={true}
                                              style={dropperStyle}
                                              accept="image/x-png,image/jpeg,image/pjpeg,image/png,image/gif,image/bmp,image/x-windows-bmp">
                                        <span className="caption">Drag image here, or click to <br/>choose image.</span>
                                    </Dropzone>
                                </form>

                                <Row className="mt-30">
                                    <Col xs={6} className="text-left">
                                        <div className="checkbox-custom d-inline-box margin-top-10">
                                            <input type="checkbox" className="form-control border-0 cursor-pointer"
                                                   id='selectAll' onChange={() => this.checkedAll()}
                                                   checked={this.state.clipArts && this.state.clipArts.length && !this.state.clipArts.find(item => !item.isChecked)}
                                                   style={{height: 'unset'}} name="isCheckAll"/>
                                            <label className="form-check-label cursor-pointer" htmlFor="selectAll">
                                                Select All
                                            </label>
                                            {/*<span>Select All</span>*/}
                                        </div>
                                    </Col>
                                    <Col xs={6} className="text-right">
                                        <div className="d-flex w-50 margin-left-auto">
                                            <i className="ma material-icons"
                                               style={{lineHeight: "38px", height: "33px", fontSize: '24px'}}>search</i>
                                            <input className="form-control" type="text" value={this.state.keyword}
                                                   onChange={this.onSearch}
                                                   placeholder="Search..."/>
                                        </div>
                                    </Col>
                                </Row>

                                <div className="w-100 overflow-auto">
                                    <table className="mt-15">
                                        <thead>
                                        <tr style={{backgroundColor: "#e1e1e1"}}>
                                            <th className="min-width-40 w-5"></th>
                                            <th className="w-40">
                                                <span>File Name</span>
                                                {
                                                    this.state.sortName === 'DESC' ?
                                                        <i className="ma material-icons font-size-20 cursor-pointer pull-right"
                                                           onClick={() => this.onSort('sortName', 'sortCategory', ASC)}>arrow_drop_up</i>
                                                        :
                                                        <i className="ma material-icons font-size-20 cursor-pointer pull-right"
                                                           onClick={() => this.onSort('sortName', 'sortCategory', DESC)}>arrow_drop_down</i>
                                                }
                                            </th>
                                            <th className="w-40 min-width-100">
                                                <span>Category</span>
                                                {
                                                    this.state.sortCategory === 'DESC' ?
                                                        <i className="ma material-icons font-size-20cursor-pointer pull-right"
                                                           onClick={() => this.onSort('sortCategory', 'sortName', ASC)}>arrow_drop_up</i>
                                                        :
                                                        <i className="ma material-icons font-size-20 cursor-pointer pull-right"
                                                           onClick={() => this.onSort('sortCategory', 'sortName', DESC)}>arrow_drop_down</i>
                                                }
                                            </th>
                                            <th className="w-5 min-width-82">Action</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {
                                            this.state.clipArts && this.state.clipArts.map(item =>
                                                (<tr key={item.clipArtId}>
                                                    <td>
                                                        <div className="checkbox-custom cursor-pointer">
                                                            <input type="checkbox"
                                                                   className="form-control border-0 checkbox-primary cursor-pointer"
                                                                   id={`checkbox${item.clipArtId}`}
                                                                   onChange={() => this.checkClipArtItem(item)}
                                                                   checked={item.isChecked}
                                                                   style={{height: 'unset'}}/>
                                                        </div>
                                                    </td>
                                                    <td>{item.name}</td>
                                                    <td>{item.category}</td>
                                                    <td>
                                                        <i className="ma material-icons font-size-30 cursor-pointer text-primary margin-right-5"
                                                           onClick={() => {
                                                               this.setState({clipArtPreview: item})
                                                           }}>visibility</i>
                                                        <i className="ma material-icons font-size-30 cursor-pointer"
                                                           onClick={() => {
                                                               this.setState({deleteClipArts: [item.imageId]})
                                                           }}>delete</i>
                                                    </td>
                                                </tr>)
                                            )
                                        }
                                        </tbody>
                                    </table>
                                </div>

                                <Row className="mt-30">
                                    <Col xs={6} md={6} className="text-left">
                                        <button type="button" id="delete-selected" className="btn btn-primary"
                                                disabled={this.state.clipArts.filter(item => item.isChecked).length <= 1}
                                                onClick={() => {
                                                    let deleteClipArts = this.state.clipArts.filter(item => item.isChecked);
                                                    this.setState({
                                                        deleteClipArts: deleteClipArts.map(item => item.imageId)
                                                    })
                                                }
                                                }>
                                            Delete Selected
                                        </button>
                                    </Col>
                                    <Col xs={6} md={6} className="text-right">
                                        {
                                            this.state.totalPage > 1 &&
                                            <div className="pagination-custom">
                                                <button className={`${!this.state.isPrevPage && 'disabled'}`} disabled={!this.state.isPrevPage}
                                                        onClick={() => this.onClickPage(0)}>&laquo;</button>
                                                <button  className={`${!this.state.isPrevPage && 'disabled'}`} disabled={!this.state.isPrevPage}
                                                        onClick={() => this.onClickPage(this.state.page - 1)}>{'<'}</button>
                                                {this.generatePageNumber()}
                                                <button  className={`${!this.state.isNextPage && 'disabled'}`} disabled={!this.state.isNextPage}
                                                        onClick={() => this.onClickPage(this.state.page + 1)}>{'>'}</button>
                                                <button  className={`${!this.state.isNextPage && 'disabled'}`} disabled={!this.state.isNextPage}
                                                        onClick={() => this.onClickPage(this.state.totalPage)}>&raquo;</button>
                                            </div>
                                        }
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Warning Delete modal popup*/}
                <Modal
                    show={!!(this.state.deleteClipArts && this.state.deleteClipArts.length)}
                    size="xs"
                    className={'modal-remove-group'}
                    onHide={() => this.setState({deleteClipArts: []})}
                    aria-labelledby="contained-modal-title-center">
                    <ModalBody>
                        <ModalHeader closeButton>
                            <h4>Are You Sure?</h4>
                        </ModalHeader>
                        <div className={'text-center'}>
                            You are about to delete {this.state.deleteClipArts.length} {this.state.deleteClipArts.length === 1 ? 'file' : 'files'},
                            <br/> do you want to continue?
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button onClick={() => this.setState({deleteClipArts: []})}>Cancel</Button>
                        <Button onClick={this.removeClipArt}
                                className={'btn btn-primary create_button_hover'}>
                            Continue
                        </Button>
                    </ModalFooter>
                </Modal>

                {/* Preview Clip arts modal*/}
                <Modal
                    show={!!this.state.clipArtPreview}
                    className={'modal-remove-group'}
                    onHide={() => this.setState({clipArtPreview: null})}
                    aria-labelledby="contained-modal-title-center">
                    <ModalBody>
                        <ModalHeader closeButton>
                            <h4>Clipart Preview</h4>
                        </ModalHeader>
                        <div className={'text-center'}>
                            <Image ref={"imgLib" + (this.state.clipArtPreview && this.state.clipArtPreview.imageId)}
                                   src={'/images/' + (this.state.clipArtPreview && this.state.clipArtPreview.imageId + '/data')}
                                   alt={(this.state.clipArtPreview && this.state.clipArtPreview.name)}
                                   className='image-index-thumbnail w-100'/>
                            <div className='text-left mt-15'>
                                {this.state.clipArtPreview && this.state.clipArtPreview.name}
                            </div>
                        </div>
                    </ModalBody>
                </Modal>

                {/* Warning Upload modal popup*/}
                <Modal
                    show={!!(this.state.textWarning)}
                    size="xs"
                    className={'modal-remove-group'}
                    onHide={() => this.setState({textWarning: ''})}
                    aria-labelledby="contained-modal-title-center">
                    <ModalBody>
                        <ModalHeader closeButton>
                            <h4>Oops! This file is too big!</h4>
                        </ModalHeader>
                        <div className={'text-center'}>
                            {this.state.textWarning}
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button onClick={() => this.setState({textWarning: ""})}>OK</Button>
                    </ModalFooter>
                </Modal>
            </div>
        )
    }
}

// Which props do we want to inject, given the global state?
// Note: use https://github.com/faassen/reselect for better performance.
function mapStateToProps(state) {
    // stuff to chain down to dumb components
    // for now -- pass through the whole state
    return state
}

export default connect(mapStateToProps)(ClipArtManagementPage)



// WEBPACK FOOTER //
// ./src/components/ClipArtManagementPage.jsx